// Citation cleanup. Answers stay markdown — react-markdown renders the
// headings, tables and lists the clerk emits. This pass only pulls the
// filing-system markers out of the prose and lists the pages once at the end.
//
// Corpus collections — the taxonomy the assistant cites from. Matching on the
// collection (rather than any "word/word") keeps ordinary prose such as
// "(and/or)" out of the citation stripper.
const COLLECTIONS =
  "canon|entities|playbooks|synthesis|concepts|partners" +
  "|source_library|worked_examples|corpus|skills";
const CITE_ID = "(?:" + COLLECTIONS + ")\\/[a-z0-9][a-z0-9\\/_-]*";

export function stripMd(t: string): string {
  let s = t || "";
  // Citations arrive inline as "(canon/x)", "[playbooks/y]" or the doubled
  // "([id](id))" link form. An employee wants the answer, not the filing
  // system: pull every marker out of the prose and list the pages once.
  const ids = new Set<string>();
  const take = (_m: string, id: string) => {
    ids.add(id);
    return "";
  };
  s = s
    // ([id](id)) and [id](id)
    .replace(
      new RegExp("\\s*\\(?\\[(" + CITE_ID + ")\\]\\(" + CITE_ID + "\\)\\)?", "g"),
      take,
    )
    // [id]
    .replace(new RegExp("\\s*\\[(" + CITE_ID + ")\\]", "g"), take)
    // (id) and (id, id)
    .replace(
      new RegExp(
        "\\s*\\((" + CITE_ID + ")(?:\\s*[,;]\\s*" + CITE_ID + ")*\\)",
        "g",
      ),
      take,
    )
    // bare trailing id
    .replace(
      new RegExp("\\s*(?:^|(?<=\\s))(" + CITE_ID + ")(?=[\\s.,;:)]|$)", "g"),
      take,
    )
    .replace(/\(\s*\)/g, "")
    .replace(/[ \t]+([.,;:!?])/g, "$1")
    .replace(/[ \t]{2,}/g, " ")
    .replace(/\n{3,}/g, "\n\n");
  if (ids.size) {
    const names = [...ids].map((i) =>
      i.split("/").pop()!.replace(/[-_]/g, " "),
    );
    s += "\n\nSources: " + [...new Set(names)].join(" · ");
  }
  return s;
}
